import { generatedName, riderChroma } from '../shared/rider';
import { isRiderHidden } from './hiddenRiders';

const RIDER_ID = /^rider_[a-f0-9]{32}$/;
export const riderNickname = generatedName;

/** Report and Hide are offered for other real riders only: not yourself, SnowBot or local test riders. */
export function canModerateRider(playerId?: string | null, selfId?: string | null): boolean {
  return typeof playerId === 'string' && RIDER_ID.test(playerId) && playerId !== selfId;
}

/**
 * The colour to draw a rider in. A rider this player hid gets the default
 * colour for their id, never the one they chose.
 */
export function shownRiderChroma(chroma: number | undefined, playerId: string): number | undefined {
  return isRiderHidden(playerId) ? riderChroma(undefined, playerId) : chroma;
}

function isNpcPlayer(playerId?: string | null): boolean {
  return typeof playerId === 'string' && playerId.startsWith('NPC_');
}

function clean(value?: string | null): string {
  return (value ?? '').trim();
}

export function maskPlayerName(username?: string | null, playerId?: string | null): string {
  // A hidden rider is only ever their generated nickname on this device.
  if (playerId && isRiderHidden(playerId)) return generatedName(playerId);
  // Public rider payloads contain only the server-projected shown name.
  if (playerId && RIDER_ID.test(playerId)) return clean(username) && !/^Rider-[A-F0-9]+$/i.test(clean(username)) ? clean(username) : generatedName(playerId);
  const name = clean(username);
  if (isNpcPlayer(playerId)) return name || 'SnowBot';

  if (name) {
    if (name.length <= 1) return `${name}...`;
    if (name.length <= 3) return `${name[0]}...`;
    return `${name.slice(0, 2)}...${name.slice(-1)}`;
  }

  const fallback = clean(playerId).replace(/[^a-z0-9]/gi, '');
  if (!fallback) return 'Pl...r';
  if (fallback.length <= 3) return `${fallback[0]}...`;
  return `${fallback.slice(0, 2)}...${fallback.slice(-1)}`;
}

export function playerInitials(username?: string | null, playerId?: string | null): string {
  if (playerId && RIDER_ID.test(playerId)) return maskPlayerName(username, playerId).split(' ').map(word => word[0]).join('').slice(0, 2).toUpperCase();
  const source = clean(username) || clean(playerId);
  const letters = source.replace(/[^a-z0-9]/gi, '');
  return (letters.slice(0, 2) || '??').toUpperCase();
}
